module.exports = __webpack_public_path__ + "media/images/proof_links/colored/apple-1177f4ce1b1cc0b8ce9ad2b2b6ab4961.svg";